import { useEffect, useState } from "react";
import { Button, Col, Row, Select, Space, } from "antd";
import ExternalAccountsTable from "./ExternalAccountsTable";
import usePayouts from "hooks/finance/usePayouts";
import WidgetSectionTitle from "widgets/WidgetSectionTitle";
import useUsers from "hooks/userManagement/useUsers";

export default function ExternalAccountsPage() {
  const {
    externalAccounts,
    fetchExternalAccounts,
    fetchActiveExternalAccounts,
    loading,
  } = usePayouts();
  const { searchUserProfiles } = useUsers();
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const [showActiveOnly, setShowActiveOnly] = useState(false);

  // mocking
  // const [externalAccounts, setExternalAccounts] = useState([]);
  // const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (showActiveOnly) {
      fetchActiveExternalAccounts(selectedUserId);
    } else {
      fetchExternalAccounts(selectedUserId);
    }
  }, [
    selectedUserId,
    showActiveOnly,
    fetchExternalAccounts,
    fetchActiveExternalAccounts,
  ]);

  // async search handler for Select
  const handleSearchUser = async (value) => {
    if (!value) return setUserOptions([]);
    try {
      const users = await searchUserProfiles(value);
      setUserOptions(
        users.map((u) => ({
          label: `${u.firstName} ${u.lastName} (${u.email})`,
          value: u.id,
        })),
      );
    } catch (err) {
      console.error("Failed to search users", err);
    }
  };

  // for mocking
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setExternalAccounts(mockedAccounts);
  //     setLoading(false);
  //   }, 1000);

  //   return () => clearTimeout(timer);
  // }, []);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2 mt-2 gap-3">
        <WidgetSectionTitle
          icon="envelope-open-text"
          title="External Payout Accounts"
          subtitle="Manage all payment charge configurations"
          className="mb-3 mt-3 flex-1"
        />
      </div>

      {/* filter bar */}
      <Row gutter={[10, 10]} style={{ marginBottom: 16, alignItems: "center" }}>
        <Col>
          <Space>
            <Button
              type={!showActiveOnly ? "primary" : "default"}
              onClick={() => setShowActiveOnly(false)}
            >
              All Accounts
            </Button>
            <Button
              type={showActiveOnly ? "primary" : "default"}
              onClick={() => setShowActiveOnly(true)}
            >
              Active Accounts
            </Button>
          </Space>
        </Col>
        <Col style={{ marginLeft: "auto" }}>
          <Select
            showSearch={{
              filterOption: false,
              onSearch: handleSearchUser,
            }}
            placeholder="Search and select user"
            allowClear
            onChange={(val) => setSelectedUserId(val)}
            options={userOptions}
            style={{ width: 300 }}
          />
        </Col>
        <Col>
          <Button onClick={() => setSelectedUserId(null)}>Clear Filter</Button>
        </Col>
      </Row>

      <ExternalAccountsTable accounts={externalAccounts} loading={loading} />
    </div>
  );
}
